var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.861 5.36C12.228 2.59 12.912 1.203 14 1.203c1.088 0 1.771 1.385 3.139 4.155l.455.923c.399.809.598 1.213.948 1.467s.795.318 1.687.448l1.019.148c3.057.444 4.585.666 4.921 1.7.337 1.036-.77 2.114-2.982 4.27l-.736.718c-.646.63-.969.944-1.102 1.355-.134.41-.057.855.095 1.743l.174 1.014c.522 3.045.783 4.568-.097 5.207-.88.64-2.247-.08-4.981-1.517l-.911-.479c-.798-.42-1.197-.629-1.63-.629-.431 0-.83.21-1.628.63l-.91.478c-2.735 1.438-4.102 2.156-4.982 1.517-.88-.64-.62-2.162-.097-5.206l.174-1.015c.152-.888.229-1.332.095-1.743-.133-.411-.456-.726-1.102-1.355l-.737-.718C2.6 12.159 1.494 11.08 1.83 10.045c.337-1.034 1.865-1.256 4.922-1.7l1.019-.148c.892-.13 1.338-.194 1.687-.448.35-.254.549-.658.948-1.467l.455-.923Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar28);
export default __webpack_public_path__ + "static/media/star_28.6388c787.svg";
export { ForwardRef as ReactComponent };